import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { CiterneEcartGroup, EnginConsommationRow, EnginConsommationGroupRow, EnginGasoilRow } from '@/types';

interface ChartState {
  citernesEcart: CiterneEcartGroup[];
  enginConsommationTable: EnginConsommationRow[];
  enginConsommationLineChart: EnginConsommationGroupRow[];
  enginConsommationBarChart: EnginGasoilRow[];
}

const initialState: ChartState = {
  citernesEcart: [],
  enginConsommationTable: [],
  enginConsommationLineChart: [],
  enginConsommationBarChart: [],
};

const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {
    setCiternesEcart(state, action: PayloadAction<CiterneEcartGroup[]>) {
      state.citernesEcart = action.payload ?? [];
    },
    setEnginConsommationTable(state, action: PayloadAction<EnginConsommationRow[]>) {
      state.enginConsommationTable = action.payload ?? [];
    },
    setEnginConsommationLineChart(state, action: PayloadAction<EnginConsommationGroupRow[]>) {
      state.enginConsommationLineChart = action.payload ?? [];
    },
    setEnginConsommationBarChart(state, action: PayloadAction<EnginGasoilRow[]>) {
      state.enginConsommationBarChart = action.payload ?? [];
    },
  },
});

export const {
  setCiternesEcart,
  setEnginConsommationTable,
  setEnginConsommationLineChart,
  setEnginConsommationBarChart,
} = chartSlice.actions;
export default chartSlice.reducer;
